module.exports = __webpack_public_path__ + "assets/img/bg-male-27780aa7.png";